// ======================
// Sticky Header magic
// ======================
export default class StickyHeader {
    constructor(selector = '.js-site__header') {
        this.header = document.querySelector(selector);
        if (!this.header) return;

        this.lastScroll = window.scrollY;
        this.init();
    }

    init() {
        window.addEventListener('scroll', () => this.handleScroll(), { passive: true });
    }

    handleScroll() {
        const currentScroll = window.scrollY;

        if (currentScroll < this.lastScroll && currentScroll > 0) {
            this.header.classList.add('sticky', 'visible');
        } else {
            this.header.classList.remove('sticky', 'visible');
        }

        this.lastScroll = currentScroll;
    }
}